/* global window, document */
const rtbContainerId = 'cl-marketing-rtb';

export type MarketingRTBRec = ({
    type: 'home';
} | {
    type: 'card';
    offerId: string;
} | {
    type: 'search';
    categoryId?: string;
    offerIds: readonly string[];
}) & {
    userId?: string;
};

export function marketingSendRTB(p: MarketingRTBRec) {
    const prefix = '';
    const hash = 'VXWJk6F110WN2fYLgqwi';

    const key = '__rtbhouse.lid';
    let lid = window.localStorage.getItem(key);

    if (! lid) {
        lid = '';
        const pool = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

        for (let i = 0; i < 20; i++) {
            lid += pool.charAt(Math.floor(Math.random() * pool.length));
        }

        window.localStorage.setItem(key, lid);
    }

    const sr = encodeURIComponent(document.referrer ? document.referrer : '');
    const su = encodeURIComponent(document.location.href ? document.location.href : '');
    const tmstmp = encodeURIComponent(String(Date.now()));

    const rtbhTags = [];

    const pr = `pr_${hash}_`;

    if (p.type === 'home') rtbhTags.push(pr + 'home');
    if (p.type === 'card') rtbhTags.push(pr + `offer_${p.offerId}`);
    if (p.type === 'search') {
        if (p.categoryId) {
            // only new or only second
            rtbhTags.push(pr + `category_${p.categoryId}`);
        } else {
            // mixed serp
            rtbhTags.push(pr + `listing_${p.offerIds.join(',')}`);
        }
    }

    rtbhTags.push(pr + 'uid_' + (p.userId ?? 'unknown'));
    rtbhTags.push(pr + 'lid_' + lid);

    let ifrSrc = 'https://' + prefix + 'creativecdn.com/tags?type=iframe';

    for (let i = 0; i < rtbhTags.length; i++) {
        ifrSrc += '&id=' + encodeURIComponent(rtbhTags[i]);
    }

    ifrSrc += '&su=' + su + '&sr=' + sr + '&ts=' + tmstmp;

    const ifr = document.createElement('iframe');

    ifr.id = rtbContainerId;
    ifr.setAttribute('src', ifrSrc);
    ifr.setAttribute('width', '1');
    ifr.setAttribute('height', '1');
    ifr.setAttribute('scrolling', 'no');
    ifr.setAttribute('frameBorder', '0');
    ifr.setAttribute('style', 'display:none');
    ifr.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');

    const prev = document.getElementById(ifr.id);

    prev && document.body.removeChild(prev);

    if (document.body) {
        document.body.appendChild(ifr);
    } else {
        window.addEventListener('DOMContentLoaded', function() {
            document.body.appendChild(ifr);
        });
    }
}
